// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const state = function () {
  return { error: null };
};
